import React from "react";
import { useIntl } from "umi";
import classNames from "classnames";
import { Switch } from "tea-component";
import ConfirmAndCancel from "@/pages/datalab/components/ConfirmAndCancle";
import './index.scss';

/**
 * CompareSwitch 组件 Props 接口
 */
interface ICompareSwitchProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange'> {
  value: boolean;
  onChange: (value: boolean) => void;
  onConfirm: () => void;
  onCancel: () => void;
  className?: string;
  disabledSwitch?: boolean;
}

const CompareSwitch = (props: ICompareSwitchProps) => {
  const { value, onChange, onConfirm, onCancel, className, disabledSwitch, ...rest } = props;
  const { formatMessage } = useIntl();
  return (<div  className={classNames("dbl-compare-switch", className)} {...rest}>
    {
      disabledSwitch ? '' : (<>
        <span
          className="dbl-compare-switch-label">{formatMessage({id: 'dbl_time_compare_title'})}</span>
        <Switch
          value={value}
          onChange={onChange}
        />
      </>)
    }
    <ConfirmAndCancel
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  </div>);
};

export default CompareSwitch;
